/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {LinkCopyRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {LinkCopyResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const linkCopy = (request: LinkCopyRequest, options?: CashRequestOptions) => post<LinkCopyRequest, LinkCopyResponse>("/2.0/cash/link-copy", request, {...options, rejectOnError: true })